// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"thumbnail_7q5jp","thumbnailItem":"thumbnailItem_398dh","title":"title_f4rlg"};